// extracted by mini-css-extract-plugin
export default {"howMuch":"HowMuch_howMuch__k8fMz"};